/*
This function deep-compares previous and next render props for use with React.memo
It will ALSO compare function props shallowly. This is slow, 
so you should use comparePropsIgnoringFunctions whenever possible.
MAKE SURE TO USE REACT.USECALLBACK WHEN USING FUNCTION PROPS! THIS WILL NOT WORK OTHERWISE!
*/
export function compareComplexProps(prevProps, nextProps) {
  let propsEqual = JSON.stringify(prevProps) === JSON.stringify(nextProps);
  if (propsEqual) {
    const functionKeys = Object.keys(prevProps).filter(props => typeof prevProps[props] === 'function');
    propsEqual = functionKeys.every(key => prevProps[key] === nextProps[key]);
  }
  return propsEqual;
}

/*
This function deep-compares previous and next render props for use with React.memo
It will ignore function props, and will break when passed React ref or children props
For situations where those matter to your comparison, write a custom comparison function
or don't use React.memo
*/
export function comparePropsIgnoringFunctions(prevProps, nextProps) {
  return JSON.stringify(prevProps) === JSON.stringify(nextProps);
}
